import { Link } from "react-router-dom";
import "./menu.scss";

export default function Menu({ menuOpen, setMenuOpen }) {
  return (
    <div className={"menu "+(menuOpen && "active")}>
      <ul>
        <li onClick={()=>setMenuOpen(false)}>
          <Link to={"/"}>Home</Link>
        </li>
        <li onClick={()=>setMenuOpen(false)}>
          <Link to={"/project"}>Portfolio</Link>
        </li>
        
        <li onClick={()=>setMenuOpen(false)}>
          <Link to={"/competence"}
          >Compétences</Link>
        </li>
        <li onClick={()=>setMenuOpen(false)}>
          <Link to={"/contact"}>Contact</Link>
        </li>
      </ul>
    </div>
  );
}